__turbopack_context__.v({
  "className": "myfont_c1e9d13b-module__xOaR3a__className",
  "variable": "myfont_c1e9d13b-module__xOaR3a__variable",
});
